<div
    *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf=" !openengagement && global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col-12">
        <h4 class="mb-2 font-header-1">Inbox</h4>
    </div>
    <div class="col-12 mt-3 p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent">
                <div class="row">

                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Start Date <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col">
                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','StartDate')"
                                [selDate]="FilterStartDate" (dateChanged)="newdates($event,'datechanged','StartDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">End Date <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col">
                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','EndDate')" [selDate]="FilterEndDate"
                                (dateChanged)="newdates($event,'datechanged','EndDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Channel</label>
                        </div>
                        <div class="col">                       
                           <ng-select [(ngModel)]="IBO.channelName" [searchable]="true" [clearable]="true"
                                        [items]="ChannelNameList" bindLabel="Value" bindValue="Key" id="channelName">
                                    </ng-select>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Queue</label>
                        </div>
                        <div class="col">
                            <ng-select [(ngModel)]="IBO.queueName" [searchable]="true" [clearable]="true"
                                        [items]="QueueNameList" bindLabel="Value" bindValue="Key" id="queue">
                                    </ng-select>                      
                        </div>
                    </div> 
                             
                </div>
                <div class="row">
                   
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Inbox Id</label>
                        </div>
                        <div class="col"> 
                            <ng-select class="w-100" [(ngModel)]="IBO.engagementIds" [multiple]="true"
                            [items]="InboxDropdown" bindValue='Key' bindLabel="Value">
                          </ng-select>                
                        </div>
                    </div>   
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Status</label>
                        </div>
                        <div class="col"> 
                            <ng-select class="w-100" [(ngModel)]="IBO.statusLid" 
                            [items]="status" bindValue='id' bindLabel="lovName">
                          </ng-select>                
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col">
                            <label class="fs-size">Assignee</label>
                        </div>
                        <div class="col"> 
                            <ng-select class="w-100" [(ngModel)]="IBO.assignedEmployeeId" 
                            bindLabel="Value" bindValue="Key" [items]="EmployeeDropdown">
                          </ng-select>                
                        </div>
                    </div>    
                     <div class="col-3" *ngIf="this.clientTab !== 'clienttab'">
                    <div class="col">
                        <label class="fs-size">Customer Type</label>
                    </div>
                    <div class="col mt-1">
                        <ng-select [(ngModel)]="IBO.customerType" [searchable]="true" [clearable]="true"
                                    [items]="CustomerTypeList" bindLabel="Value" bindValue="Key" id="queue">
                          </ng-select>                      
                    </div>
                </div> 
                           
                </div>
                <div class="row">
                     <div class="col-3" *ngIf="IBO.customerType == 'CLIENT' && this.clientTab !== 'clienttab'" >
                    <div class="col">
                        <label class="fs-size">Client</label>
                    </div>
                    <div class="col mt-1">
                        <ng-select [(ngModel)]="IBO.customerId" [searchable]="true" 
                            [clearable]="true" [items]="AllClientDropDownListwithStatus" bindLabel="Value" class="tdropdown"
                            bindValue="Key">
                        </ng-select>
                    </div>
                </div> 

                </div>
            
    
                <div class="row mt-3">
                    <div class="col">
                        <button class="btn btn-sm me-2" style="float: right;" (click)="clearengagement()">
                            Refresh
                        </button>  
                        <button class="btn btn-sm me-2" style="float: right;" [disabled]="FilterStartDate==null || FilterStartDate==undefined ||
                                    FilterStartDate=='' ||
                                    FilterEndDate==null || FilterEndDate==undefined ||
                                    FilterEndDate=='' "  (click)="getEngagementsListFilter()">
                            Apply
                        </button>  
                    </div>
                </div>
            </div>
            <div class="card-body transparent">

                <div class="row mt-2 pt-1">
                    <div class="col-12">
                        <ejs-grid #inboxgrid id="inboxgrid" [dataSource]='InboxGrid | async' [allowResizing]='true'
                            [allowSorting]='true' [showColumnChooser]='true' [allowPaging]='true'
                            [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
                            [pageSettings]='initialPage' [filterSettings]='filterOptions'
                            (actionComplete)="onActionComplete($event)" [selectionSettings]='selectionOptions'>

                            <e-columns>
                                <!-- (rowSelected)="onRowSelected($event)"  -->
                                <e-column field='' headerText="Actions" width="100" [showInColumnChooser]='false' 
                                    textAlign='center'>
                                    <ng-template #template let-data>
                                        <button *ngIf="fp?.inboxEdit" class="btn btn-edit-table" (click)="EditEngagement($event,data)"> <i
                                                class="fa fa-edit"></i></button>

                                    </ng-template>
                                </e-column>

                                <e-column field="engagementId" headerText="Id" textAlign="left" type="string"
                                    width="300" [allowFiltering]='false'>
                                    <ng-template #template let-data>
                                        <div class="d-flex align-items-center">
                                            <span class="text-truncate d-inline-block" style="width: 300px;">
                                                {{ data.engagementId }}
                                            </span>
                                            <button class="btn btn-sm btn-light ms-2"
                                                (click)="copyToClipboard(data.engagementId)">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </div>
                                    </ng-template>
                                </e-column>
                                <e-column field="channelName" headerText="Channel Name" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="queueName" headerText="Queue Name" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="dialedFrom" headerText="Dialed From" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="dialedTo" headerText="Dialed To" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="startTime" headerText="Start Time" width="200" textAlign='left'
                                    type="datetime" [format]='datetimeformat' [allowFiltering]='false'>
                                </e-column>
                                 <e-column field="endTime" headerText="End Time" width="200" textAlign='left'
                                    type="datetime" [format]='datetimeformat' [allowFiltering]='false'>
                                </e-column>
                                 <e-column field="totalDuration" headerText="Duration" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="customerType" headerText="Customer Type" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <!-- Consultant Name -->
                                <e-column field="customerName" headerText="Customer Name" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="customerPhone" headerText="Customer Phone" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                 
                                 <e-column field="customerEmail" headerText="Customer Email" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column field="assignedEmployeeName" headerText="Assignee" width="150"
                                    textAlign='left' [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="statusLovName" headerText="Status" width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div class="d-none d-lg-block">
                                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <div class="col-lg-12">
                        <div *ngIf="InboxGrid.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="row mb-3" *ngIf="openengagement">
    <div class="col-lg-6 " >
        <h4 class="mb-0 font-header-1" 
        style="font-weight: 700;"><label (click)="clearengagement()"><i class="fa fa-chevron-circle-left"
            title="Close" style="font-size:24px"></i></label>&nbsp;Inbox</h4>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 mb-2  text-end">
        <button class="btn btn-sm" *ngIf="fp?.inboxSave" (click)="saveInbox()">
            Save
        </button> &nbsp;
        <button class="btn btn-sm" (click)="clearengagement()">
            Close
        </button>
    </div>

    <div class="modal-content border border-2 ">
        
                <div class="row mb-2">
                    <div class=" col pl-0">
                       
                            <div class="card-body widget-body pt-2">
                            
                                <div class="row mt-2">
                                    <div class="col-lg-6">
                                        <h5 class="pt-2 font-header-green">Inbox Details</h5>
                                      </div>                                 
                                    
                                </div>
                       
                           
                                <div class="row mt-3">
                                    <div class="col-lg-12">
                                        <div class="row ">
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Engagement ID </label>
                                                <input type="text" class="form-control w-90" 
                                                     [(ngModel)]="InboxData.engagementId"
                                                    [disabled]="true">
                                            </div>  
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Customer Name</label>
                                                <input type="text" class="form-control w-90" name="customerName"
                                                    id="customerName" [(ngModel)]="InboxData.customerName"
                                                    [disabled]="true">
                                            </div>
                                        </div>
                                        <div class="row mt-2 ">
                                             <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Queue Name</label>
                                                <input type="text" class="form-control w-90" name="queueName"
                                                    id="queueName" [(ngModel)]="InboxData.queueName"
                                                    [disabled]="true">
                                            </div>
                                             <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Dialed from</label>
                                                <input type="text" class="form-control w-90" name="dialedFrom"
                                                    id="dialedFrom" [(ngModel)]="InboxData.dialedFrom"
                                                    [disabled]="true">
                                            </div>                                            
                                                                                 
                                        </div>
                                        <div class="row mt-2 ">
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Dialed To</label>
                                                <input type="text" class="form-control w-90" name="dialedTo"
                                                    id="dialedTo" [(ngModel)]="InboxData.dialedTo"
                                                    [disabled]="true">
                                            </div>  
                                             <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Start Time</label>
                                                <input type="text" class="form-control w-90" name="startTime"
                                                    id="startTime" [(ngModel)]="InboxData.startTime"
                                                    [disabled]="true">
                                            </div>                                                                                                                               

                                        </div>

                                        <div class="row  mt-2">

                                           <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">End Time</label>
                                                <input type="text" class="form-control w-90" name="endTime"
                                                    id="endTime" [(ngModel)]="InboxData.endTime"
                                                    [disabled]="true">
                                            </div>   
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Customer Type</label>
                                                <input type="text" class="form-control w-90" name="customerType"
                                                    id="customerType" [(ngModel)]="InboxData.customerType"
                                                    [disabled]="true">
                                            </div>                                                                                     
                                                      
                                        </div>
                                        <div class="row mt-2">
                                             <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Channel Name</label>
                                                <input type="text" class="form-control w-90" name="channelName"
                                                    id="channelName" [(ngModel)]="InboxData.channelName"
                                                    [disabled]="true">
                                            </div>    
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Customer Phone</label>
                                                <input type="text" class="form-control w-90" name="customerPhone"
                                                    id="customerPhone" [(ngModel)]="InboxData.customerPhone"
                                                    [disabled]="true">
                                            </div>                                            

                                        </div>
                                        <div class="row  mt-2">
                                              <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Customer Email</label>                                               
                                                  <input type="text" class="form-control w-90" cols="190" name="customerEmail"
                                                id="customerEmail"
                                                [(ngModel)]="InboxData.customerEmail" [disabled]="true">
                                            </div> 
                                            
                                           <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Status</label>
                                                <ng-select class="d-inline-flex w-90"
                                                    [(ngModel)]="InboxData.statusLid" id="status"
                                                    bindLabel="lovName" bindValue="id" [items]="status">
                                                </ng-select>
                                            </div>                                           
                                           
                                        </div>
                                           <div class="row  mt-2">
                                             <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Follow Up Notes</label>
                                                <textarea rows="7" class="form-control w-90" cols="190"
                                                    [(ngModel)]="InboxData.notes"></textarea>
                                            </div>                                           
                                            <div class="col-6 d-flex">
                                                <label class="me-2 label w-50">Assignee</label>
                                                <ng-select class="d-inline-flex w-90"
                                                    [(ngModel)]="InboxData.assignedEmployeeId"
                                                    id="assignedEmployeeId" bindLabel="Value" bindValue="Key"
                                                    [items]="EmployeeDropdown">
                                                </ng-select>

                                            </div>  
                                        </div>
                                    </div>
                                </div>

                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <h5 class="mt-2 font-header-green">Linked Tickets</h5>
                                      </div>
                                      <div class="col-lg-6 text-end">
                                        <button *ngIf="fp?.ticketLink" type="button" class="btn btn-sm me-2" data-bs-toggle="modal"
                                            data-bs-target="#linkModal" id="assigncompanyTable">Link Ticket
                                        </button>
                                        <button *ngIf="fp?.ticketCreate" type="button" class="btn btn-sm" (click)="createTicket();" id="assigncompanyTable">Create Ticket
                                        </button>

                                    </div>
                                    </div>
               
    
                                

                                <div class="row">
                                    <div class="col-12">
                                        <div class="mt-2">
                                            <ejs-grid #grid id='grid' [dataSource]="TicketsList "
                                                [allowResizing]='true' [enablePersistence]="true"
                                                [allowReordering]="true" 
                                                [showColumnChooser]='false'>

                                                <e-columns>

                                                    <e-column width=100 headerText='Actions' uid="action"
                                                        [showInColumnChooser]='false'>
                                                        <ng-template #template let-data>
                                                            <button  *ngIf="fp?.ticketEdit" class="btn btn-edit-table" (click)="EditTicket(data)" title="Edit Ticket"
                                                            data-bs-toggle="modal" data-bs-target="#ticketModal">
                                                            <i class="fa fa-edit"></i></button>  &nbsp;
                                                            <button *ngIf="fp?.ticketUnlink" class="btn btn-delete-table Ationsubbtn"                                                             
                                                                data-bs-target="#Deletetickets"
                                                                data-bs-toggle="modal"
                                                                title="Unlink"
                                                                (click)="selectedItem(data)"><i
                                                                class="fa fa-chain-broken" ></i></button>
                                                            &nbsp;&nbsp;

                                                        </ng-template>
                                                        <!-- (click)="edittimesheet(data,$event)" -->
                                                    </e-column>
                                                    <e-column field='uniqueTicketId' headerText="Ticket Id"
                                                        width=160 textAlign='left' [allowEditing]='false'
                                                        type='string'>
                                                        <ng-template #template let-data>
                                                            <div class="d-flex align-items-center">
                                                              <span class="text-truncate d-inline-block" style="width: 160px;">
                                                                {{ data.uniqueTicketId }}
                                                              </span>
                                                              <button class="btn btn-sm btn-light ms-2" (click)="copyToClipboard(data.uniqueTicketId)">
                                                                <i class="fa fa-copy"></i>
                                                              </button>
                                                            </div>                    
                                                          </ng-template>
                                                    </e-column>
                                                    <e-column field='title' headerText="Title" width=160
                                                        textAlign='left' [allowEditing]='false' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>

                                                    <e-column field='statusLovName' headerText="Status"
                                                        textAlign='left' width=100 [allowEditing]='false'
                                                        type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>



                                                    <e-column field='priorityLovName' headerText="Priority"
                                                        width=130 textAlign='left' [allowEditing]='false'
                                                        type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='ticketTypeLovName' headerText="Type"
                                                        width=120 textAlign='left' [allowEditing]='false'
                                                        type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='employeeName' headerText="Assignee" width=90
                                                        textAlign='center' [allowEditing]='false' type='string'
                                                        [allowSorting]='false'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='createdTime' headerText="Created Date"
                                                        width=130 textAlign='left' [format]='datetimeformat'
                                                        [allowEditing]='false' type='date' [allowFiltering]='false'>
                                                    </e-column>
                                                    <e-column field='modifiedTime' headerText="Last Modified Date"
                                                        width=130 textAlign='left' [format]='datetimeformat'
                                                        [allowEditing]='false' [allowFiltering]='false' type='date'>
                                                    </e-column>
                                                    <e-column field='createdBy' headerText="Created by" width=130
                                                        textAlign='center' [allowEditing]='false' type='string'
                                                        [allowSorting]='false'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='modifiedBy' headerText="Modified by" width=130
                                                        textAlign='center' [allowEditing]='false' type='string'
                                                        [allowSorting]='false'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox
                                                                placeholder="Enter the value"></ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>

                                                   

                                                </e-columns>
                                            </ejs-grid>
                                        </div>

                                    </div>

                                </div>

                            </div>
                       


                    </div>

                </div>
         

        
    
    </div>
</div>


<span id="openlinkticket" data-bs-toggle="modal" data-bs-target="#linkModal"> </span>

<div class="modal fade" id="linkModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="warningModalLabel">Link Tickets</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="LinkTicket.ticketIds=[]"></button>
            </div>
            <div class="modal-body">
                <div class="row  mt-2">
                    <div class="col-12 d-flex">
                        <label class="me-2 label w-25">Link Tickets</label>
                        <ng-select class="w-90" [(ngModel)]="LinkTicket.ticketIds" [multiple]="true" [items]="tickets"
                            bindValue='Key' bindLabel="Value">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" (click)="LinkTicketsList()">Link</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                    (click)="LinkTicket.ticketIds=[]">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="openticket" data-bs-toggle="modal" data-bs-target="#ticketModal"> </span>

<div class="modal fade" id="ticketModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="SaveTickets.id == '00000000-0000-0000-0000-000000000000' "  class="modal-title " id="warningModalLabel">Create Tickets</h5>
                <h5 *ngIf="SaveTickets.id != '00000000-0000-0000-0000-000000000000' " class="modal-title " id="warningModalLabel">Update Tickets</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="card-body widget-body pt-2">
                    <!-- <div class="row">
                        <div class="col-lg-12">
                            <div class="row ">
                                <div class="col-6 d-flex">
                                    <label class="me-2 label w-50">Title</label>
                                    <input type="text" class="form-control w-100" name="Title" id="TicketTitle"
                                        [(ngModel)]="SaveTickets.title">
                                </div>

                                <div class="col-6 d-flex">
                                    <label class="me-2 label w-50">Assignee</label>
                                    <ng-select class="d-inline-flex w-100" [(ngModel)]="SaveTickets.employeeId"
                                        id="ClientListQpEmployeeId" bindLabel="Value" bindValue="Key"
                                        [items]="EmployeeDropdown">
                                    </ng-select>
                                </div>

                            </div>
                            <div class="row mt-2 ">
                                <div class="col-6 d-flex">
                                    <label class="me-2 label w-50">Status</label>
                                    <ng-select class="d-inline-flex w-100" [(ngModel)]="SaveTickets.statusLid"
                                        id="ClientListQpEmployeeId" bindLabel="lovName" bindValue="id"
                                        [items]="TicketStatus">
                                    </ng-select>
                                </div>
                                <div class="col-6 d-flex">
                                    <label class="me-2 label w-50">Priority</label>
                                    <ng-select class="d-inline-flex w-100" [(ngModel)]="SaveTickets.priorityLid"
                                        id="ClientListQpEmployeeId" bindLabel="lovName" bindValue="id"
                                        [items]="TicketPriority">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="row mt-2 ">
                                <div class="col-6 d-flex">
                                    <label class="me-2 label w-50">Ticket Type</label>
                                    <ng-select class="d-inline-flex w-100" [(ngModel)]="SaveTickets.ticketTypeLid"
                                        id="ClientListQpEmployeeId" bindLabel="lovName" bindValue="id"
                                        [items]="TicketType">
                                    </ng-select>
                                </div>

                            </div>
                            <div class="row mt-2">
                                <div class="col-12 d-flex">
                                    <label class="me-2 label " style="width: 19%;">Summary</label>
                                    <textarea rows="7" class="form-control" cols="190"
                                        [(ngModel)]="SaveTickets.summary"></textarea>
                                </div>
                            </div>

                        </div>
                    </div> -->
                    <form [formGroup]="ticketsForm">

                        <div class="row mt-2 ms-2 p-10">
            
                          <div class="col-lg-4">
                            <div class="row mb-2">
                              <div class="col ">
                                <div widget class="card border-0 box-shadow">
                                  <div class="card-body widget-body pt-2">
                                    <div class="row mt-2" *ngIf="SaveTickets.id != '00000000-0000-0000-0000-000000000000' " >

                                        <div class="col-lg-12">
                                          <label>Ticket Id
                                          </label>
                                        </div>
                                        <div class="col-lg-12">
                                             <input class="form-control" [ngModelOptions]="{standalone: true}" 
                                              [(ngModel)]="SaveTickets.uniqueTicketId" [disabled]="true" >                        
              
                                        </div>
                                      </div>
            
                                    <div class="row mt-2">
            
                                      <div class="col-lg-12">
                                        <label>Status<sup class="super-script">&nbsp; *</sup>
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
            
                                        <ng-select formControlName="status" [(ngModel)]="SaveTickets.statusLid" [searchable]="true" [clearable]="false"
                                        [items]="TicketStatus" bindLabel="lovName" class="tdropdown" bindValue="id">
                                        </ng-select>
            
                                      </div>
                                    </div>
            
                                    <div class="row mt-2">
            
                                      <div class="col-lg-12">
                                        <label>Priority
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
            
                                        <ng-select formControlName="priority" [(ngModel)]="SaveTickets.priorityLid" [searchable]="true" [clearable]="true"
                                        [items]="TicketPriority" bindLabel="lovName" class="tdropdown" bindValue="id">
                                        </ng-select>
            
                                      </div>
                                    </div>
                                    <div class="row mt-2">
            
                                      <div class="col-lg-12">
                                        <label>Type<sup class="super-script">&nbsp; *</sup>
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
            
                                        <ng-select formControlName="tickettype" [(ngModel)]="SaveTickets.ticketTypeLid" [searchable]="true" [clearable]="false"
                                        [items]="TicketType" bindLabel="lovName" class="tdropdown" bindValue="id">
                                        </ng-select>
            
                                      </div>
                                    </div>
                                    <div class="row mt-2">
            
                                      <div class="col-lg-12">
                                        <label>Assignee<sup class="super-script">&nbsp; *</sup>
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
            
                                        <ng-select formControlName="assignee" [(ngModel)]="SaveTickets.employeeId" [searchable]="true" [clearable]="false"
                                        [items]="EmployeeDropdown" bindLabel="Value" class="tdropdown" bindValue="Key">
                                        </ng-select>
            
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                    
                                        <div class="col-lg-12">
                                            <label>Customer
                                            </label>
                                        </div>
                                        <div class="col-lg-12">
                                    
                                            <ng-select [(ngModel)]="SaveTickets.clientId" [searchable]="true" [ngModelOptions]="{standalone:true}"
                                                [clearable]="true" [items]="AllClientDropDownListwithStatus" bindLabel="Value" class="tdropdown"
                                                bindValue="Key">
                                            </ng-select>
                                    
                                        </div>
                                    </div>
            
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-8">
                            <div class="row mb-2">
                              <div class="col ">
                                <div widget>
                                  <div>
            
                                    <div class="row">
            
                                      <div class="col-lg-12">
                                        <label>Title<sup class="super-script">&nbsp; *</sup>
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
                                        <input type="text" class="form-control" formControlName="title" [(ngModel)]="SaveTickets.title"
                                          >
                                        <span class="help-block text-danger text-center"
                                          *ngIf="!ticketsForm.get('title').valid && ticketsForm.get('title').touched ">
                                          <p>Please Enter Title</p>
                                        </span>
                                      </div>
                                    </div>
            
            
                                    <div class="row mt-2">
            
                                      <div class="col-lg-12">
                                        <label>Description<sup class="super-script">&nbsp; *</sup>
                                        </label>
                                      </div>
                                      <div class="col-lg-12">
                                        <textarea rows="7" class="form-control" cols="190" style="min-height: 170px" formControlName="description" [(ngModel)]="SaveTickets.summary"></textarea>
            
                                      </div>
                                      <!-- <div class="col-lg-12 "> -->
                                      <!-- app.component.html -->
                                      <!--   
                                          <div (click)="toggleEditor()" *ngIf="!isEditorActive">
                                            <input type="text" class="form-control" formControlName="description">
                                          </div>
                                          <div *ngIf="isEditorActive">
                                            <quill-editor    #editor placeholder="Add a Description..."  formControlName="description" 
                                              [modules]="modules"></quill-editor>
                                          </div>
              
              
                                        </div> -->
                                    </div>
                                    <!-- <div class="row mt-2">
              
                                        <div class="col-lg-12">
                                          <label>Attachments
                                          </label>
                                        </div>
                                        <div class="col-lg-12">
              
                                          <div class="custom-file">
                                            <label class="custom-file-label" for="customFile">Choose file</label>
                                            <input class="custom-file-input" id="customFile" type="file"
                                              (change)="onFileSelected($event)" multiple accept="image/*, .pdf, .docx" />
              
                                            <div class="file-list" *ngIf="files.length > 0">
                                              <div class="file-item" *ngFor="let file of files">
                                                <div>{{ file.name }}</div>
                                            
              
                                                <button *ngIf="(file.document != null && file.document !='' && file.document != undefined)" (click)="downloadFile(file)"><i class="fa fa-download"></i></button>
                                                <button  *ngIf="file.document == null || file.document =='' || file.document == undefined" (click)="downloadUnsavedFile(file)"><i class="fa fa-download"></i></button>
                                                <button (click)="removeFile(file)"><i class="fa fa-trash"></i></button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> -->
            
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
            
            
                        </div>
                      </form>

                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="SaveTickets.id == '00000000-0000-0000-0000-000000000000' " [disabled]="!ticketsForm.valid" type="button" class="btn btn-sm" (click)="createTickets('create')">Create</button>
                <button *ngIf="SaveTickets.id != '00000000-0000-0000-0000-000000000000' " [disabled]="!ticketsForm.valid" type="button" class="btn btn-sm" (click)="createTickets('update')">Update</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="OpenDeletetickets" data-bs-toggle="modal" data-bs-target="#Deletetickets"></span>
<div class="modal fade modalbackgrod" id="Deletetickets" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Unlink Ticket</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                Are you sure want to unlink this ticket?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteTickets()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>